import styled, { css } from "styled-components";
import { Label as BootstrapLabel } from "react-bootstrap";
const getColorStyles = (theme, bsStyle) => {
  if (!bsStyle) {
    return "";
  }
  const { color, background } = theme.colors.button[bsStyle === "default" ? "gray" : bsStyle];
  return css`
    background-color: ${background};
    color: ${color};
    font-weight: normal;
  `;
};
const StyledLabel = styled(BootstrapLabel)(
  ({ bsStyle, theme }) => css`
    ${getColorStyles(theme, bsStyle)}
    padding: 0.3em 0.6em;
  `
);
export default StyledLabel;
